<template src="./deleteimage.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  export default {
    props: ["Item", "Type", "ItemKey", "KeyType"],
    methods: {
      DeleteImage(id) {
        this.$swal
          .fire({
            title: "Are you sure You want to delete this Image?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#514b71",
            cancelButtonColor: "#aaa",
            confirmButtonText: "Yes, delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire({
                title: "Deleting...",
                text: "Please wait...",
                showConfirmButton: false,
                allowOutsideClick: false,
              });
              Axios.post(Endpoints.Operation.ImageDelete, {
                token: localStorage.getItem("token"),
                id: id,
                type: this.Type,
                item_key: this.ItemKey,
                item_type: this.KeyType,
                
              }).then((Response) => {
                if (Response?.data?.success == true) {
                  this.$parent.LoadProfileData();
                  this.$swal
                    .fire("Image Deleted Successfully", "", "success")
                    .then(() => {});
                } else {
                  this.$swal
                    .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                    .then(() => {});
                }
              });
            }
          });
      },
    },
  };
</script>
<style scoped>
  .delete-icon {
    background: #f00;
    color: #fff;
    border-radius: 10px;
    cursor: pointer;
  }
  .delete-trailer,
  .delete-asset {
    padding: 3px 5px;
  }
  .delete-driver {
    padding: 2px 6px;
    position: absolute;
    bottom: 10px;
    right: 39%;
    z-index: 2;
  }
  .delete-vehicle-check {
    padding: 2px 6px;
    position: absolute;
    /* bottom: 10px; */
    right: 6px;
    z-index: 2;
    top: -10px;
  }
  @media screen and (max-width: 991px) {
    .width-full {
      width: 100% !important;
    }
    .delete-driver {
      right: 36%;
    }
    .delete-vehicle-check {
      top: -10px;
      right: 18px;
    }
  }
</style>
